import fetch from '../utils/fetch'

export function getUserNpCardList(query) {
  return fetch({
    url: '/duiba/usercardlist',
    method: 'get',
    params: query
  })
}

export function getUserCardRealTimePoint(query) {
  return fetch({
    url: '/duiba/user/cardRealTimePoint',
    method: 'get',
    params: query
  })
}

export function changeUserDefaultCard(query) {
  return fetch({
    url: '/duiba/user/changeUserDefaultCard',
    method: 'put',
    params: query
  })
}

export function getDuibaOrderList(query) {
  return fetch({
    url: '/duiba/orders/getlist',
    method: 'get',
    params: query
  })
}


export function getPointList(query) {
  return fetch({
    url: '/duiba/points/getlist',
    method: 'get',
    params: query
  })
}

export function getlistbyNp(query) {
  return fetch({
    url: '/duiba/points/getlistbyNp',
    method: 'get',
    params: query
  })
}

export function memberExport(query) {
  return fetch({
    url: '/member/export',
    method: 'GET',
    params: query
  })
}

export function returnPoint(query) {
  return fetch({
    url: '/duiba/points/returnPoints',
    method: 'GET',
    params: query
  })
}

export function updateUserCardMsg(query) {
  return fetch({
    url: '/duiba/user/changeUserCardMsg',
    method: 'put',
    params: query
  })
}

// ----------------------积分商城-----------------------

export function getGoodList(query) {
  return fetch({
    url: '/duiba/pointGoods/getGoodslist',
    method: 'get',
    params: query
  })
}

export function updateItems(itemId, query) {
  return fetch({
    url: '/duiba/pointGoods/updateItems/' + itemId,
    method: 'put',
    data: query,
    refreshToken: true
  })
}

export function createItems(query) {
  return fetch({
    url: '/duiba/pointGoods/save',
    method: 'post',
    data: query,
    refreshToken: true
  })
}
export function delItems(id) {
  return fetch({
    url: '/duiba/pointGoods/delItems/' + id,
    method: 'delete'
  })
}

export function updateCategory(itemId, query) {
  return fetch({
    url: '/duiba/pointCategory/updateCategory/' + itemId,
    method: 'put',
    data: query,
    refreshToken: true
  })
}
export function createCategory(query) {
  return fetch({
    url: '/duiba/pointCategory/save',
    method: 'post',
    data: query,
    refreshToken: true
  })
}
export function goodsExport (query) {
  return fetch({
    url: '/duiba/pointGoods/goodsExport',
    method: 'get',
    params: query
  })
}
export function orderExport (query) {
  return fetch({
    url: '/duiba/pointOrder/orderExport',
    method: 'get',
    params: query
  })
}




export function getBannerList(query) {
  return fetch({
    url: '/duiba/pointBasic/getBannerList',
    method: 'get',
    params: query
  })
}

export function updateBanner(id,query) {
  return fetch({
    url: '/duiba/pointBasic/edit/' + id,
    method: 'put',
    data: query,
    refreshToken: true
  })
}

export function createBanner(query) {
  return fetch({
    url: '/duiba/pointBasic/save',
    method: 'post',
    data: query,
    refreshToken: true
  })
}

export function delBanner(id) {
  return fetch({
    url: '/duiba/pointBasic/del/' + id,
    method: 'delete'
  })
}






export function getOrderList(query) {
  return fetch({
    url: '/duiba/pointOrder/pointOrderList',
    method: 'get',
    params: query
  })
}

export function onSale (query) {
  return fetch({
    url: '/duiba/pointGoods/onSale',
    method: 'get',
    params: query
  })
}

export function getCategoryList(query) {
  return fetch({
    url: '/duiba/pointCategory/getList',
    method: 'get',
    params: query
  })
}

export function delGoods (query) {
  return fetch({
    url: '/duiba/pointGoods/delGoods',
    method: 'get',
    params: query
  })
}
export function refundPoint (query) {
  return fetch({
    url: '/duiba/pointOrder/refundPoint',
    method: 'get',
    params: query
  })
}




// WEBPACK FOOTER //
// ./src/api/duiba.js